var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"已清税"}},[_c('order-workbench',{attrs:{"show-title":false,"show-create-button":false,"extra-query-params":{ tax_cleared: 1, tax_cleared_from_administrator: 1 },"list-table-variant":'tax_cleared'}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c58e43c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/TaxClearedList.vue
// module id = 4jgG
// module chunks = 0